import React, { useEffect, useState } from 'react';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { Tab } from '@gerdau/hefesto';
import LoyaltyRoutes, { ELoyaltyRoutes } from '../loyalty.routes';
import { GetFlag } from '../../../utils/featureFlag';

export const HeaderTabs: React.FC = () => {
  const [activeKey, setActiveKey] = useState(ELoyaltyRoutes.LOYALTY_COINS);
  const { path } = useRouteMatch();
  const history = useHistory();
  const { pathname } = history.location;

  const onTabClick = (tab: string) => {
    history.push(`${path}${tab}`);
    setActiveKey(tab as ELoyaltyRoutes);
  };

  useEffect(() => {
    if (pathname.includes(ELoyaltyRoutes.LOYALTY_HOW_WORKS)) {
      return setActiveKey(ELoyaltyRoutes.LOYALTY_HOW_WORKS);
    }
    if (pathname.includes(ELoyaltyRoutes.LOYALTY_COINS)) {
      return setActiveKey(ELoyaltyRoutes.LOYALTY_COINS);
    }
    if (pathname.includes(ELoyaltyRoutes.LOYALTY_REWARDS)) {
      return setActiveKey(ELoyaltyRoutes.LOYALTY_REWARDS);
    }
    if (pathname.includes(ELoyaltyRoutes.LOYALTY_SIMULATOR)) {
      return setActiveKey(ELoyaltyRoutes.LOYALTY_SIMULATOR);
    }
    return setActiveKey(ELoyaltyRoutes.LOYALTY_COINS);
  }, [pathname]);

  const getTabs = () => {
    const aba_resgate = GetFlag('aba_resgate');
    const aba_meus_pontos = GetFlag('aba_meus_pontos');
    const aba_como_funciona = GetFlag('aba_como_funciona');
    const aba_simulador = GetFlag('aba_simulador');
    const tabs = [];
    if (aba_meus_pontos) {
      tabs.push({
        key: ELoyaltyRoutes.LOYALTY_COINS,
        content: <LoyaltyRoutes />,
        name: 'Meus pontos'
      });
    }
    if (aba_simulador) {
      tabs.push({
        key: ELoyaltyRoutes.LOYALTY_SIMULATOR,
        content: <LoyaltyRoutes />,
        name: 'Simulador'
      });
    }
    if (aba_resgate) {
      tabs.push({
        key: ELoyaltyRoutes.LOYALTY_REWARDS,
        content: <LoyaltyRoutes />,
        name: 'Resgate'
      });
    }
    if (aba_como_funciona) {
      tabs.push({
        key: ELoyaltyRoutes.LOYALTY_HOW_WORKS,
        content: <LoyaltyRoutes />,
        name: 'Como funciona?'
      });
    }
    return tabs;
  };

  return (
    <Tab
      tabPosition="top"
      tabItems={getTabs()}
      activeKey={activeKey}
      onChange={onTabClick}
    ></Tab>
  );
};

export default HeaderTabs;
